<ng-diversions-submit-details
  *ngIf="(store$ | async) as store"
  [summary]="store.sumDetailsSummary"
  [requestForm]="store.sumDetailsForm"
  [privateForm]="store.sumDetailsPrivateCarForm"
  [originTurnoverForm]="store.sumOriginTurnoverForm"
  [reshipForm]="store.sumDetailsReshipForm"
  [reshipCars]="store.reshipCars"
  [destTuroverForm]="store.sumDestTurnoverForm"
  [type]="store.type"
  (submitAnotherRequest)="dispatchUpdateRequestForm($event)"
  (submitAnotherPrivateCar)="dispatchUpdatePrivateCarForm($event)"
  (submitOriginTurnover)="dispatchUpdateOriginTurnoverForm($event)"
  (submitAnotherDestTurnover)="dispatchUpdateDestTurnoverForm($event)"
  (submitAnotherReship)="dispatchUpdateReshipForm($event)">
</ng-diversions-submit-details>
